// extracted by mini-css-extract-plugin
export var card = "_al-1";
export var container = "_al-0";